import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { PLAN_DAYS, PLAN_MEALS, addDays, shortDate, weekLabel } from "@/lib/mealPlan";

export function WeekPicker({ weekStart, onChange }) {
  return (
    <div className="flex items-center justify-between gap-2" data-testid="plan-week-picker">
      <button type="button" onClick={() => onChange(addDays(weekStart, -7))} aria-label="Previous week" data-testid="plan-week-prev"
              className="w-9 h-9 rounded-full border border-rf-ink/15 flex items-center justify-center hover:bg-rf-cream"><CaretLeft size={16} /></button>
      <span className="font-bold text-sm text-rf-ink" data-testid="plan-week-label">{weekLabel(weekStart)}</span>
      <button type="button" onClick={() => onChange(addDays(weekStart, 7))} aria-label="Next week" data-testid="plan-week-next"
              className="w-9 h-9 rounded-full border border-rf-ink/15 flex items-center justify-center hover:bg-rf-cream"><CaretRight size={16} /></button>
    </div>
  );
}

// Days down the side, meals across: fits a phone screen. `cell(day, meal)` returns {text, state}.
export function PlanWeekGrid({ weekStart, cell, onPick }) {
  return (
    <div className="space-y-1.5" data-testid="plan-week-grid">
      <div className="grid grid-cols-[40px_repeat(4,minmax(0,1fr))] gap-1.5 text-[10px] font-bold uppercase tracking-wider text-rf-ink-soft">
        <span />
        {PLAN_MEALS.map((m) => <span key={m.key} className="text-center truncate">{m.label}</span>)}
      </div>
      {PLAN_DAYS.map((d, i) => (
        <div key={d.key} className="grid grid-cols-[40px_repeat(4,minmax(0,1fr))] gap-1.5">
          <div className="leading-tight self-center">
            <p className="text-xs font-bold text-rf-ink">{d.label}</p>
            <p className="text-[10px] text-rf-ink-soft">{shortDate(addDays(weekStart, i))}</p>
          </div>
          {PLAN_MEALS.map((m) => {
            const { text, state } = cell(d.key, m.key);
            const tone = state === "new" ? "bg-rf-orange text-white border-rf-orange"
              : state === "replace" ? "bg-red-50 text-red-800 border-red-300"
              : state === "taken" ? "bg-rf-cream-alt text-rf-ink-soft border-transparent"
              : "bg-white text-rf-ink-soft border-dashed border-rf-ink/20 hover:border-rf-orange hover:bg-rf-amber/10";
            return (
              <button key={m.key} type="button" onClick={() => onPick(d.key, m.key)} data-testid={`plan-cell-${d.key}-${m.key}`}
                      title={text || `${d.label} ${m.label}`}
                      className={`h-12 rounded-lg border px-1 text-[10px] leading-tight font-semibold overflow-hidden transition-colors ${tone}`}>
                <span className="line-clamp-2">{text || "+"}</span>
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
